// extracted by mini-css-extract-plugin
export default {"ErrorWrapper":"JSXParsingError_ErrorWrapper__SoyLW","BorderedError":"JSXParsingError_BorderedError__fcAWy","ErrorHelper":"JSXParsingError_ErrorHelper__OE5AY"};